import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { RequestHeaderTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestHeaderTP'
import { AuthUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/utils/AuthUtils'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { AppConfig } from 'config/AppConfig'

/**
 * REQUISICOES relacionadas ao modulo de SysAdmin.
 */
export class SysAdminRequests {

    private static readonly _MODULE_BASE = `${AppConfig.getInstance().apiBaseUrl}/sys-admin`

    static getSchemaDataConfig = (schema: string, authToken?: string): RequestConfigTP => {

        const headers: RequestHeaderTP[] = [AuthUtils.getSchemaHeaderConfig(schema)]
        if (!!authToken)
            headers.push(AuthUtils.getBearerAuthHeaderConfig(authToken))

        return {
            url: `${SysAdminRequests._MODULE_BASE}/schemas/${schema}`,
            method: HttpMethodEnum.GET,
            headers
        }
    }

}
